module.exports = __webpack_public_path__ + "img/27.cc9549f3.jpg";